<span
	tuiAvatar="@tui.flask-conical"
	class="chemical-thumbnail__avatar"
	[size]="size()"
	[round]="false"
></span>
